import { globalBEDateFormat } from 'common/dateFormatConfig';
import { format } from 'date-fns';
import { isMobileSchedule } from 'helpers/_helpers';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSheets } from 'store/schedule/schedulePageOperation';

export const useScheduleDayEventsLoad = (effectiveSelectedDate) => {
  const dispatch = useDispatch();
  const showAllLocations = useSelector((state) => state.schedule.showAllLocations);
  const filters = useSelector((state) => state.schedule.filters);
  const scheduleDayView = useSelector((state) => state.schedule.scheduleDayView);
  const isMobile = isMobileSchedule();

  const params = useMemo(() => ({
    date: format(effectiveSelectedDate, globalBEDateFormat),
    filters,
    isCrewLeader: scheduleDayView === 'cl',
    isGridView: scheduleDayView === 'grid',
    isMobile,
    showAllLocations,
  }), [effectiveSelectedDate, filters, showAllLocations, scheduleDayView, isMobile])

  const getScheduleDayEvents = useCallback(() => {
    return dispatch(getSheets(params));
  }, [params, dispatch])

  useEffect(() => {
    getScheduleDayEvents();
  }, [getScheduleDayEvents]);

  return {
    getScheduleDayEvents,
  };
};

export default useScheduleDayEventsLoad;

